import { pages } from 'src/routing/pages'

export const isAuthZone = (p: string) =>
    p.startsWith(pages.Login.path) ||
    p.startsWith(pages.Registration.path) ||
    p.startsWith(pages.ResetPasswordRequest.path) ||
    p.startsWith(pages.ResetPasswordChange.path)

export const isMyZone = (p: string) => p.startsWith('/my/')
